import React from 'react'
import { Table } from 'antd'
import { SelectedSeries } from '../components/Chart'
import { buildTableColumns, buildTableData } from './indicator-table.util'

type Props = {
  series: SelectedSeries[]
}

export const IndicatorTable: React.FC<Props> = ({ series }) => {
  const columns = buildTableColumns(series)
  const data = buildTableData(series)

  return <Table columns={columns} dataSource={data} pagination={false} scroll={{ y: 400, x: true }} />
}
